module.exports = __webpack_public_path__ + "img/stick_activites_trotinette.56f59851.svg";